export default __webpack_public_path__ + "static/media/cover3.834e8723.jpg";